import React from "react";

const PrivateDashboard = ({ data }) => {
  return (
    <div>
      <h3>Private Tour Dashboard</h3>
      <table>
        <thead>
          <tr>
            {Object.keys(data[0]).map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.values(row).map((value, colIndex) => (
                <td key={colIndex}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PrivateDashboard;
